import React, { useState } from "react";
import { Modal, Alert, Button } from "react-bootstrap";

/**
 * 날짜 포맷
 * @param {*} data
 * @returns
 */
export const getDateFormat = (data) => {
  var date = new Date(data);
  var year = date.getFullYear();
  var month = ("0" + (1 + date.getMonth())).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  return year + "-" + month + "-" + day;
};

export const NotFound = () => {
  return (
    <div>
      <h1>페이지를 찾을 수 없습니다. </h1>
    </div>
  );
};

export const EmptyBlank = () => {
  return (
    <Alert
      variant="info"
      style={{
        visibility: "hidden",
        width: "100%",
        textAlign: "center",
      }}
    ></Alert>
  );
};

export const ContentHeader = ({ text }) => {
  return (
    <Alert variant="info" style={{ width: "100%" }}>
      {text}
    </Alert>
  );
};

export const ContentFooter = ({ text }) => {
  return (
    <Alert
      variant="info"
      style={{
        width: "100%",
        textAlign: "center",
      }}
    >
      {text}
    </Alert>
  );
};

/**
 * 대화 상자
 * type: string
 * msg: strng
 * show: bool
 * hanldeClose:function
 */
export const ModalDlgConfirm = ({ type, msg, show, handleClose }) => {
  const getTitle = {
    info: "정보",
    successed: "성공",
    failed: "실패",
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{getTitle[type]}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{msg}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

/**
 * 인증 코드 모달 상자
 * @auth {code:인증코드, beginDate:유효 시작일, endDate:유효 종료일}
 * @returns
 */
export const ModalAuthCode = ({
  code,
  beginDate,
  endDate,
  show,
  handleClose,
}) => {
  return (
    <Modal size="xl" centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>인증 코드</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>코드</div>
        <div
          style={{
            fontSize: "20vw",
            textAlign: "center",
          }}
        >
          {code}
        </div>
        <p>
          유효기간 : {getDateFormat(beginDate)} 부터 {getDateFormat(endDate)}
          까지
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
